module.exports = __webpack_public_path__ + "static/talladegahh-bf973396516ff6c5b030fafea3d318d3.jpg";